import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import HighlightText from "../atoms/HighlightText";

export default function HighlightTextWithLogic(props) {
  const navigate = useNavigate();
  const { persistItemsReducer } = useSelector((state) => state);
  const { loginReducer } = useSelector((state) => state);

  const handleClick = (text) => {
    if (
      persistItemsReducer?.selectedSOData?.soCode === "NZLO" &&
      loginReducer?.getSOConfiguration?.addNewChildUrl !== "" &&
      !text
        ?.toLowerCase()
        ?.includes("account" || "rekeninggegevens" || "détails du compte")
    ) {
      window.location.href = loginReducer?.getSOConfiguration?.addNewChildUrl;
    } else {
      props?.destroyAlert && props?.destroyAlert();
      props?.setNoSponsorChildError && props?.setNoSponsorChildError(false);
      if (persistItemsReducer?.selectedSOData?.soCode === "JPNO" && text) {
        window.open("https://www.worldvision.or.jp/form/child/entry_input", "_blank");
      } else {
        if (window.location.pathname.includes("/home")) {
          navigate("/myaccount", { state: { navigateFrom: "home" } });
        } else {
          navigate("/myaccount");
        }
      }
    }
  };

  return (
    <HighlightText
      {...props}
      onHighlightClick={handleClick}
    />
  );
}
